import { PublicTenders } from './PublicTenders';

export function PublicTendersPage() {
  return <PublicTenders type="tenders" />;
}
